import React, { FormEvent } from 'react';
import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { Nav } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from '@nkr/views/donors/swap-donors/styles';
import { LinkContainer } from 'react-router-bootstrap';

interface IProps {
    activeKey: string,
    centerId: number,
    onTabSelect: (key: string) => void
}

const ActionCenterNav = (props: IProps) => {
    const { app } = useAppHookContext();

    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const hrefPrefix = `/center/${props.centerId}/reports/my-center/composite-score-dashboard`;

    const show = app.site.organType == OrganType.Kidney;

    const tabs = [
        { eventKey: 'NCS-SCORE', label: <>Net Chains Started (NCS) Score</>, href: hrefPrefix + '/ncs-score', show },
        { eventKey: 'COMPOSITE-SCORE', label: <>Composite Score</>, href: hrefPrefix + '/composite-score', show },
        { eventKey: 'TCE-FORMULA', label: <>Targeted Chain Ends (TCE) Formula</>, href: hrefPrefix + '/tce-formula', show: app.center.isAdpPartner },
    ]

    return (
        <NavWrapper height='30px'>
            <div style={{ padding: 0, backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='swap-donor-pills'>
                    {tabs.filter(x => x.show).map((tab, index) =>
                        <>
                            {index > 0 && (
                                <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                            )}
                            <LinkContainer to={tab.href}>
                                <NavItemWrapper key={'tab-' + index} active={props.activeKey == tab.eventKey} eventKey={tab.eventKey} href={tab.href}>{tab.label}</NavItemWrapper>
                            </LinkContainer>
                        </>
                    )}
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default ActionCenterNav;